import {
  Building2,
  Camera,
  Clapperboard,
  Heart,
  Music2,
  Sparkles,
  UtensilsCrossed,
  type LucideIcon,
} from 'lucide-react';

export type CategoryAccent = {
  text: string;
  iconBg: string;
  link: string;
  ring: string;
};

/** Palette L Benna — accents par catégorie (rouge, rose, or, ambre). */
const ACCENT_PALETTE: CategoryAccent[] = [
  {
    text: 'text-primary-400',
    iconBg: 'bg-primary-500',
    link: 'text-primary-400 hover:text-primary-300',
    ring: 'ring-primary-500/40',
  },
  {
    text: 'text-rose-400',
    iconBg: 'bg-rose-500',
    link: 'text-rose-400 hover:text-rose-300',
    ring: 'ring-rose-500/40',
  },
  {
    text: 'text-accent-400',
    iconBg: 'bg-accent-500',
    link: 'text-accent-400 hover:text-accent-300',
    ring: 'ring-accent-500/40',
  },
  {
    text: 'text-orange-400',
    iconBg: 'bg-orange-500',
    link: 'text-orange-400 hover:text-orange-300',
    ring: 'ring-orange-500/40',
  },
  {
    text: 'text-primary-300',
    iconBg: 'bg-primary-600',
    link: 'text-primary-300 hover:text-primary-200',
    ring: 'ring-primary-400/40',
  },
];

const SLUG_ICON_MAP: Record<string, LucideIcon> = {
  clips: Music2,
  'clips-musicaux': Music2,
  mariage: Heart,
  mariages: Heart,
  gastronomie: UtensilsCrossed,
  immobilier: Building2,
  corporate: Building2,
  studio: Camera,
  evenement: Sparkles,
  evenements: Sparkles,
};

export function getCategoryAccent(index: number): CategoryAccent {
  return ACCENT_PALETTE[index % ACCENT_PALETTE.length];
}

export function getCategoryIcon(slug?: string, name?: string): LucideIcon {
  const key = (slug || name || '').toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
  for (const [needle, icon] of Object.entries(SLUG_ICON_MAP)) {
    if (key.includes(needle.replace('-', '')) || key.includes(needle)) return icon;
  }
  return Clapperboard;
}

export function countPortfolioPhotos(items: { coverUrl?: string; galleryUrls?: string[] }[]): number {
  let total = 0;
  for (const item of items) {
    if (item.coverUrl) total += 1;
    total += item.galleryUrls?.filter(Boolean).length ?? 0;
  }
  return total;
}
